import api from "@core/plugins/api";

const getCampaignUrl = (origin) => `/${origin}/campaign`;

export class MarketingService {
  // origin can either be "et" for an etab or "ex" for candidates
  static async getCampaignContent({ origin = "et" }) {
    try {
      const { data } = await api.private.get(getCampaignUrl(origin));
      return data;
    } catch (error) {
      throw error;
    }
  }
}
